import { Box, Flex } from '@welbe/design-system';
import { Actions } from '../Actions/Actions';
import { UsersTable } from '../UsersTable/UsersTable';
import { formattedRows } from './Doctor.builder';
import { columns } from './Doctor.constants';
import { useDoctor } from './Doctor.hooks';
import { DoctorDrawer } from './DoctorDrawer/DoctorDrawer';
import { DoctorFilters } from './DoctorFilters/DoctorFilters';

export const Doctor = () => {
	const {
		selectedUser,
		isUserModalVisible,
		setUserModalVisible,
		handleEditUser,
		handleToggleUserModal,
		handleToggleStatus,
		data,
		loading,
		totalAmount,
		currentPage,
		handleSearch,
		handleFilters,
		handleChangePage,
		filters,
	} = useDoctor();

	return (
		<>
			<Box bg="white" p="0 1.25rem 1.25rem" w="100%">
				<Actions handleOpenModalAddUser={() => setUserModalVisible(true)} />
				<Flex direction="column" gap="12px" w="100%">
					<DoctorFilters
						filters={filters}
						onChangeFilters={handleFilters}
						onSearch={handleSearch}
					/>
					<UsersTable
						headers={columns}
						rows={formattedRows(data, handleEditUser, handleToggleStatus)}
						loading={loading}
						currentPage={currentPage}
						totalAmount={totalAmount}
						pageSize={filters.pageSize}
						onPageChange={handleChangePage}
					/>
				</Flex>
			</Box>
			<DoctorDrawer
				open={isUserModalVisible}
				setOpen={handleToggleUserModal}
				user={selectedUser}
			/>
		</>
	);
};
